import { scaleSequential } from 'd3-scale';
import { interpolateViridis } from 'd3-scale-chromatic';

export type RouteColorScale = (count: number) => string;

export function makeRouteColorScale(maxCount: number): RouteColorScale {
  const safeMax = Math.max(1, maxCount);
  const scale = scaleSequential(interpolateViridis).domain([0, Math.log2(safeMax + 1)]);
  return (count: number) => scale(Math.log2(Math.max(0, count) + 1));
}
